let $ = require('jquery');
let slick = require('slick-carousel');

let Homepage = (function Homepage() {
  let pub = {};
  let priv = {
    container: document
  };

  priv.init = function init() {
    priv.attachHandlers();
    return pub;
  };

  priv.bindTestimonialSlider = function bindTestimonialSlider(testimonials) {
    let slides = testimonials.querySelector('.testimonials');
    let slideTrigger = testimonials.querySelector('.testimonial-trigger-link');
    $(slides).slick({
      autoplay: true,
      autoplaySpeed: 10000,
      fade: true,
      nextArrow: slideTrigger,
      prevArrow: slideTrigger,
      speed: 800,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            fade: false
          }
        }
      ]
    });
  };

  priv.attachHandlers = function attachHandlers() {
    priv.bindTestimonialSlider(priv.container.querySelector('.testimonial-container'));
  };

  return priv.init();
})();


module.exports = Homepage;


// WEBPACK FOOTER //
// ./htdocs/content/themes/tpt-national/assets/js/modules/Homepage/Homepage.js